// extracted by mini-css-extract-plugin
export default {"Error":"error_Error__Miq6x"};